import script from "./AccountServices.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountServices.vue?vue&type=script&setup=true&lang=js"

import "./AccountServices.vue?vue&type=style&index=0&id=7c035e14&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c035e14"]])

export default __exports__